export default function (context) {

	var url_arr = context.route.path.split('/').slice(1);
	for (var i in url_arr) {
		if (url_arr[i] == '') url_arr[i] = undefined;
	}
	if (url_arr[0] == 'eng') {
		context.params.lang = 'en';
		context.params.page = url_arr[1];
		context.params.inner = url_arr[2];
	} else {
		context.params.lang = 'ru';
	}
	if (url_arr[0] == 'eng' && (context.params.page === 'career' || context.params.page === 'recipes')) {
		context.redirect('301', '/eng');
	}
}


//////////////////
// WEBPACK FOOTER
// ./middleware/lang.js
// module id = ./middleware/lang.js
// module chunks = 5